import { VariantType } from '@ancon/wildcat-types'
import { Translate } from 'next-translate'

const variantTypeLabelKeys: Partial<Record<VariantType, string>> = {
  [VariantType.Glass]: 'common:variantType.glass',
  [VariantType.Bottle]: 'common:variantType.bottle',
}

/**
 * Name to show the guest for a product variant. A Glass or Bottle variant gets
 * its type appended in the guest's language, e.g. "Rödvin - Glas", since the
 * glass and bottle variants of the same product share the same name.
 */
export default function getVariantDisplayName(
  name: string | null | undefined,
  variantType: VariantType | null | undefined,
  t: Translate,
): string {
  const labelKey = variantType != null && variantTypeLabelKeys[variantType]

  if (!name || !labelKey) {
    return name ?? ''
  }

  return `${name} - ${t(labelKey)}`
}
